import { render, staticRenderFns } from "./DeleteIndex.vue?vue&type=template&id=294c55d4&"
import script from "./DeleteIndex.vue?vue&type=script&lang=js&"
export * from "./DeleteIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports